import { TextField } from "@mui/material";
import { useState } from "react";
import DialogSelectEstabelecimentos from "./DialogSelectEstabelecimentos";
import { TEstabelecimento } from "../../../types/api/financeiro/estabelecimentos";

interface SelectEstabelecimentosProps<M extends boolean = false> {
    inputLabel: string,
    value: M extends true ? TEstabelecimento[] : TEstabelecimento | null,
    onChangeValue: M extends true ? (arg: TEstabelecimento[]) => void : (arg: TEstabelecimento | null) => void,
    extraParams?: TExtraParams,
    required?: boolean,
    error?: boolean,
    multiple?: M
}

export default function SelectEstabelecimentos<M extends boolean = false>({
    inputLabel,
    value,
    onChangeValue,
    extraParams = {},
    required = false,
    error = false,
    multiple = false as M
}: SelectEstabelecimentosProps<M>) {

    const [openModal, setOpenModal] = useState<boolean>(false)

    const inputValue = multiple
        ? (value as TEstabelecimento[])?.map((item) => `${item.loja_id}-${item.loja_nome}`).join(", ")
        : value ? `${(value as TEstabelecimento).loja_id}-${(value as TEstabelecimento).loja_nome}`
            : ""
    return (
        <>
            <TextField
                {...{ required, error }}
                fullWidth
                label={inputLabel}
                value={inputValue}
                onClick={() => setOpenModal(true)}
                slotProps={{
                    inputLabel: { shrink: Boolean(value) },
                    input: { readOnly: true }
                }}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <DialogSelectEstabelecimentos
                    {...{ extraParams, multiple }}
                    open={openModal}
                    defValue={value}
                    handleClose={() => setOpenModal(false)}
                    title={inputLabel.toLowerCase()}
                    onSubmitValue={onChangeValue}
                />
            }
        </>
    )
}

export type TExtraParams = {}

